var exports = {
  "kL": "VoiceControlBar.module__container___WEFKd0",
  "UD": "VoiceControlBar.module__buttonContainer___WEFKd0",
  "x6": "VoiceControlBar.module__button___WEFKd0",
  "QV": "VoiceControlBar.module__buttonMuted___WEFKd0",
  "rp": "VoiceControlBar.module__buttonUnmuted___WEFKd0",
  "Jt": "VoiceControlBar.module__buttonDeafened___WEFKd0",
  "Zj": "VoiceControlBar.module__buttonCameraOn___WEFKd0",
  "dO": "VoiceControlBar.module__buttonSoundboardOn___WEFKd0",
  "PQ": "VoiceControlBar.module__buttonCameraOff___WEFKd0",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___WEFKd0",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___WEFKd0",
  "_p": "VoiceControlBar.module__buttonMoreOptions___WEFKd0",
  "Zt": "VoiceControlBar.module__buttonDisconnect___WEFKd0",
  "Q1": "VoiceControlBar.module__buttonSeparator___WEFKd0",
  "Se": "VoiceControlBar.module__settingsButton___WEFKd0",
  "on": "VoiceControlBar.module__stopWatchingButton___WEFKd0",
  "Kk": "VoiceControlBar.module__icon___WEFKd0",
  "Bx": "VoiceControlBar.module__iconSmall___WEFKd0",
};

module.exports = exports;
